/* eslint-disable */
import create_update from "@/apollo/flights/create_update.gql";
import listing from "@/apollo/flights/listing.gql";
import booking_returns from "@/apollo/flights/get_book_returns.gql";
import fetch_for_edit from "@/apollo/flights/fetch_for_edit.gql";
import release_inventory from "@/apollo/flights/release_inventory.gql";
import hold_inventory from "@/apollo/flights/hold_inventory.gql";
import book_inventory from "@/apollo/flights/book_inventory.gql";
import fetch_for_context from "@/apollo/flights/fetch_for_context.gql";
import get_available_seats from "@/apollo/flights/get_available_seats.gql";
import group_issue_inventory from "@/apollo/flights/group_issue_inventory.gql";

export const state = () => ({
  list: [],
  loading: false,
  creating: false,
  available_seats: ""
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jul 2023 | 05:52PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jul 2023 | 05:52PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jul 2023 | 05:52PM
   * @param {*} state
   * @param {*} value
   */
  setCreating: (state, value) => (state.creating = value),
  /**
   * @description
   * @author Saurabh Jangra
   * @date 01 Nov 2023 | 05:35PM
   * @param {*} state
   * @param {*} value
   */
  setAvailableSeats: (state, value) => (state.available_seats = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 31 Jul 2023 | 08:17PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }, search_by) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing, variables: { search_by } })
        .then(({ data }) => {
          commit("setListing", data.fetch_inventories);
          resolve(data.fetch_inventories);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 12 Aug 2023 | 01:11PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  fetchDetailsById({ commit }, search_by) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: listing, variables: { search_by } }).then(({ data }) => {
        const _item = this?.$_?.head(data.fetch_inventories);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Jul 2023 | 05:52PM
   * @param {*} { commit }
   * @returns {*}
   */
  createInventory({ commit }, payload) {
    commit("setCreating", true);
    return new Promise((resolve) => {
      this.$apolloClient
        .mutate({ mutation: create_update, variables: { payload } })
        .then(({ data }) => {
          resolve(data.create_inventory);
          commit("setCreating", false);
        })
        .catch((err) => {
          commit("setCreating", false);
        });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 05 Aug 2023 | 02:20PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  fetchReturnFlights(__, payload) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: booking_returns, variables: { payload } }).then(({ data }) => {
        resolve(data.get_inventory_book_returns);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 18 Aug 2023 | 02:54AM
   * @param {*} _
   * @param {*} payload
   * @returns {*}
   */
  fetchInventoryForEdit(_, payload) {
    return new Promise((resolve) => {
      this.$apolloClient.query({ query: fetch_for_edit, variables: payload }).then(({ data }) => {
        resolve(data.fetch_inventory_for_edit);
      });
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 02 Sep 2023 | 11:46AM
   * @param {*} { __ }
   * @param {*} payload
   * @returns {*}
   */
  releaseInventory(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { release_flight_inventory }
        } = await this.$apolloClient.mutate({ mutation: release_inventory, variables: { payload } });
        resolve(release_flight_inventory);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Sep 2023 | 12:57PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  holdInventory(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { hold_flight_inventory }
        } = await this.$apolloClient.mutate({ mutation: hold_inventory, variables: { payload } });
        resolve(hold_flight_inventory);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 27 Oct 2023 | 02:48PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  bookInventory(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { book_flight_inventory }
        } = await this.$apolloClient.mutate({ mutation: book_inventory, variables: { payload } });
        resolve(book_flight_inventory);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 26 Oct 2023 | 06:48PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  groupIssueInventory(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { group_issue_flight_inventory }
        } = await this.$apolloClient.mutate({ mutation: group_issue_inventory, variables: { payload } });
        resolve(group_issue_flight_inventory);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Sep 2023 | 09:37AM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  fetchFlightsForContext(__, payload) {
    return new Promise(async (resolve) => {
      try {
        const {
          data: { fetch_flights_for_context }
        } = await this.$apolloClient.query({ query: fetch_for_context, variables: { payload } });
        resolve(fetch_flights_for_context);
      } catch (error) {}
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 16 Oct 2023 | 03:36PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  refreshListing({ commit }, search_by) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_inventory_listing }`
      });
      for await (const event of _result) {
        this.$apolloClient.query({ query: listing, variables: { search_by } }).then(({ data }) => {
          commit("setListing", data.fetch_inventories);
          resolve(data.fetch_inventories);
        });
      }
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Oct 2023 | 03:52PM
   * @param {*} __
   * @param {*} inventory_id
   * @returns {*}
   */
  fetchAvailableSeats({ commit }, inventory_id) {
    return new Promise(async (resolve) => {
      const {
        data: { flt_inventory_available_seats }
      } = await this.$apolloClient.query({ query: get_available_seats, variables: { inventory_id } });
      commit("setAvailableSeats", flt_inventory_available_seats);
      resolve(flt_inventory_available_seats);
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading,
  creating: (state) => state.creating,
  available_seats: (state) => state.available_seats
};
